// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Reader-cls1__cac98ad608507570cb2c{/*!*/}.Reader-cls2___15abe4336118e4c66ab{flex:1 1;background:#fff;min-width:0px;display:flex;flex-direction:column}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Reader-cls1__cac98ad608507570cb2c",
	"cls2": "Reader-cls2___15abe4336118e4c66ab Reader-cls1__cac98ad608507570cb2c"
};
export default ___CSS_LOADER_EXPORT___;
